<div *ngIf="dataInitialized" class="relative h-full">
    <app-menu></app-menu>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>